import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_shared/_services/app.common.service';
@Component({
  selector: 'app-sso-login',
  templateUrl: './atsLogin.component.html',
})
export class ATSLoginRedirectComponent   {
  constructor(public common: CommonService) { }

  ngOnInit() {

    let userInfo = this.common.JsonParseData(this.common.GetFromLocalStorage('jt_user_info'));
    if (!this.common.isNullOrWhiteSpace(userInfo)) {
      this.common.loadTheme(userInfo.theme);
    }

  }

}
